import React, { useContext } from 'react'
import { ReducerContext } from '../reducers/reducerContext.js';
import FinanceFile from '../components/results/FinanceFile'

export default function ContFinanceFile() {
  const globalstate = useContext(ReducerContext);

  return (
    <FinanceFile
      context={globalstate.testCriteria.context}
      settings={globalstate.settings}
      vehicleDetails={globalstate.responseSimulation.vehicleDetails}
      financeFile={globalstate.responseSimulation.financeFile}
    />
  );
}
